import {memo, useEffect} from 'react'
import {useLocation, useParams} from 'react-router'

import {useOnce} from '../hooks/useOnce'
import {useSetLocation, useSetParams} from '../states/location'

const LocationListener = memo(function LocationListener() {
  const setLocation = useSetLocation()
  const location = useLocation()

  useOnce(() => setLocation(location))
  useEffect(() => {
    setLocation(location)
  }, [location, setLocation])

  return null
})

export const ParamsListener = memo(function ParamsListener() {
  const setParams = useSetParams()
  const params = useParams()

  useOnce(() => setParams(params))
  useEffect(() => {
    setParams(params)
  }, [params, setParams])

  return null
})

export const RouterListener = memo(function RouterListener() {
  return <>
    <ParamsListener />
    <LocationListener />
  </>
})
